import { render, staticRenderFns } from "./relationLogistics.vue?vue&type=template&id=5c12aa61&scoped=true"
import script from "./relationLogistics.vue?vue&type=script&lang=js"
export * from "./relationLogistics.vue?vue&type=script&lang=js"
import style0 from "./relationLogistics.vue?vue&type=style&index=0&id=5c12aa61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c12aa61",
  null
  
)

export default component.exports